<template>
  <div class="inquire" v-cloak>
    <div class="data-bg">
      <app-header></app-header>
      <div class="data-banner">
        <div class="data-title-box">
          <p class="data-title"><span>{{ $t('xdata.Nav_itwb') }}</span></p>
          <span
            class="data-sub">{{ $t('xdata.Its_ts') }}</span>
        </div>
      </div>
    </div>
    <div v-if="lang == 'zh-CN' ">
      <div class="u-flex u-flex-center data-content">
        <data-item :title="$t('xdata.Its_tgyw')" :sub="$t('xdata.Its_tgywt1')">
        </data-item>
        <data-item :title="$t('xdata.Its_hdcs')" :sub="$t('xdata.Its_hdcst1')">
        </data-item>
        <data-item :title="$t('xdata.Its_jscz')" :sub="$t('xdata.Its_jsczt1')">
        </data-item>
        <data-item :title="$t('xdata.Its_fdfx')" :sub="$t('xdata.Its_fdfxt1')">
        </data-item>
        <data-item :title="$t('xdata.Its_znxhd') " :sub="$t('xdata.Its_znxhdt1')">
        </data-item>
      </div>
    </div>
    <div v-else>
      <div class="u-flex u-flex-center data-content">
        <data-item :title="$t('xdata.Its_tgyw')" :sub="$t('xdata.Its_tgywt1')">
        </data-item>
        <data-item :title="$t('xdata.Its_hdcs')" :sub="$t('xdata.Its_hdcst1')">
        </data-item>
        <data-item :title="$t('xdata.Its_jscz')" :sub="$t('xdata.Its_jsczt1')">
        </data-item>
      </div>
      <div class="u-flex u-flex-center data-content">
        <data-item :title="$t('xdata.Its_fdfx')" :sub="$t('xdata.Its_fdfxt1')">
        </data-item>
        <data-item :title="$t('xdata.Its_znxhd') " :sub="$t('xdata.Its_znxhdt1')">
        </data-item>
      </div>
    </div>
    <div class="sol-content-bg">
      <div class="sol-title-box">
        
        <p class="sol-p">{{ $t('xdata.Its_ms1') }}</p>
        <img src="@/assets/img/data/it1.png" class="sol-img" v-if="lang == 'zh-CN' "/>
        <img src="@/assets/img/data/it1_en.png" class="sol-img" v-else/>
        <p class="sol-p2">{{ $t('xdata.Its_ms2') }}</p>
        <img src="@/assets/img/data/it2.png" class="sol-img" v-if="lang == 'zh-CN' "/>
        <img src="@/assets/img/data/it2_en.png" class="sol-img" v-else/>
        <img src="@/assets/img/data/it3.png" class="sol-img" v-if="lang == 'zh-CN' "/>
        <img src="@/assets/img/data/it3_en.png" class="sol-img" v-else/>
      </div>
    </div>
    <app-footer></app-footer>
  </div>
</template>

<script>

import Header from "@/components/header";
import Footer from "@/components/footer";
import DataItem from "@/components/dataItem";
import SolItem from "@/components/solItem";

export default {
  components: {
    "app-header": Header,
    "app-footer": Footer,
    "data-item": DataItem,
    "sol-item": SolItem,

  },
  name: "service",
  data() {
    return {
      lang:''
    };
  },
  created(){
    this.lang = localStorage.getItem('lang') 
  },
  mounted() {
  },
  methods: {

  }
};
</script>
<style scoped>
.data-bg {
  width: 100%;
  background: url('../../assets/img/data_bg.jpg') no-repeat fixed center center / 100% auto;
}

.data-banner {
  height: 300px;
  background: rgba(0, 0, 0, 0.3);
}

.data-title-box {
  padding-top: 60px;
  width: 1200px;
  margin: 0 auto;
}

.data-title {
  font-size: 32px;
  color: #fff;
  margin-bottom: 20px;
}

.data-sub {
  font-size: 14px;
  display: inline-block;
  width: 70%;
  color: #fff;
  line-height: 1.5;

}

.data-content {
  width: 1200px;
  min-height: 280px;
  margin: 80px auto 100px;
}

.data-item:last-of-type {
  margin-right: 0px;
}

.sol-title {
  font-size: 32px;
  color: #fff;
  margin-bottom: 20px;
}

.sol-content-text {
  color: #fff;
}

.sol-content-list {
  padding-top: 50px;
}
.sol-content-bg{
  background: #f4f4f4;
}
.sol-title-box{
  padding-top: 60px;
  width: 1200px;
  margin: 0 auto;
}

.sol-title {
  font-size: 32px;
  color: #fff;
  margin-bottom: 20px;
}

.sol-content-text {
  color: #fff;
}

.sol-content-list {
  padding-top: 50px;
}
.sol-img{
  width: 100%;
  margin: 30px 0;
}
.sol-p{
  line-height: 1.5;
  color: #6b6b6b;
}
.sol-p2{
  font-weight: bold;
  font-size: 24px;
  line-height: 1.5;
  margin: 20px 0;
}
</style>


// WEBPACK FOOTER //
// src/views/services/itsourcing.vue